import React, { useState, useEffect } from 'react';

import Img1 from '../m3dasset/01aptohenrique.jpg';
import Img2 from '../m3dasset/02aptohenrique.jpg';
import Img3 from '../m3dasset/03aptohenrique.jpg';
import Img4 from '../m3dasset/04aptohenrique.jpg';
import Img5 from '../m3dasset/05geminadosjefferson.png';
import Img6 from '../m3dasset/06aptohenrique.jpg';
import Img7 from '../m3dasset/07geminadosjefferson.png';
import Img8 from '../m3dasset/08geminadosjefferson.png';
import Img9 from '../m3dasset/09geminadosjefferson.png';
import Img10 from '../m3dasset/10geminadosasconstrucoes.png';
import Img11 from '../m3dasset/11geminadosasconstrucoes.png';
import Img12 from '../m3dasset/12geminadosasconstrucoes.png';
import Img13 from '../m3dasset/13geminadosasconstrucoes.png';
import Img14 from '../m3dasset/14geminadosasconstrucoes.png';


import './gallery.css';


import {MdNavigateNext, MdClose} from 'react-icons/md';
import {RiArrowLeftSLine} from 'react-icons/ri';
import { IconContext } from 'react-icons';
;

const images = [
  Img1,
  Img2,


  Img3,
 
  
  Img4,

  Img5,

  Img6,
  Img7,
  

 
  Img8,
  Img9,

  Img10,
 
  Img11,

 
  Img12,
  
  
  Img13,

  /*Img14,*/
 
]

const imageMap = {
  0: Img1,
  1: Img2,
  2: Img3,

  3: Img4,
  4: Img5,
  5: Img6,
  
  6: Img7,
  7: Img8,
  8: Img9,

  9: Img10,
  10: Img11,
  11: Img12,

  12: Img13,
 /* 13: Img8,
  14: Img9,

  15: Img10,
  16: img7verticalnormal,
  17: Img11,

  18: img8verticalnormal,
  19: Img12,
  20: img9verticalnormal,

  21: Img13,
  22: Img14,
  23: Img15,

  24: Img16,
  25: Img17,
  26: Img18,

    27: Img19,
    28: Img20*/
};


const Gallery = () => {

    const [data, setData] = useState({img: '', i: 0})  

    const viewImage = (img, i)=>{
        const modalImage = imageMap[i] || img; // Exibe a imagem mapeada ou a própria imagem se não houver mapeamento
        setData({ img: modalImage, i });
    }

    const imgAction = (action) => {
        let i = data.i;
        if (action === 'next-img') {
          setData({ img: images[i + 1], i: i + 1 });
        }
        if (action === 'previous-img') {
          setData({ img: images[i - 1], i: i - 1 });
        }
        if (!action) {
          setData({ img: '', i: 0 });
        }
      };

    return(
       
        <>
            {data.img &&
                <>
                    <div className='div-out'>
                        <img src={data.img} className='img-out' alt=''/>
                        <IconContext.Provider value={{ className: 'itprevious', color: 'white'}}>
                            <RiArrowLeftSLine 
                                onClick={() => imgAction('previous-img')}/>
                        </IconContext.Provider>
                        <IconContext.Provider value={{ className: 'it' }}>
                            <MdClose onClick={() => imgAction()}/>
                        </IconContext.Provider>
                        <IconContext.Provider value={{ className: 'itnext' }}>
                                <MdNavigateNext        
                                onClick={() => imgAction('next-img')}/>
                        </IconContext.Provider>
                    </div>
                </>
            }
            <div className='gallery-outer'>
                <div className='gallery-global'>
                    <GalleryColumns images={images} onClickImage={viewImage} />
                </div>
            </div>
        </>
    );
}

function GalleryColumns({ images, onClickImage }){
    const [columns, setColumns] = useState(3);

    useEffect(()=>{
        const calc = ()=>{
            const w = window.innerWidth;
            if (w <= 430) setColumns(1);
            else if (w < 750) setColumns(2);
            else setColumns(3);
        }
        calc();
        window.addEventListener('resize', calc);
        return ()=> window.removeEventListener('resize', calc);
    },[]);

    // Heights in px
    const baseH = 320;
    const tallH = 520;
    const gap = 20; // vertical gap between items

    // specific overrides for individual items (index-based)
    const heightOverrides = {
        // reduce penultimate image height so columns align (index based)
        //28: 260,
        // Img14 (index 22) - reduce height by ~40% (approx)
        //22: 164,
        10: 520,
        11: 520,
        12: 460,
        4: 521,
        7: 461,

    };

    // mark some items as tall based on pattern but distribution will go to shortest column
    const items = images.map((src, i)=>({
        src,
        i,
        height: heightOverrides[i] ?? ((i % 6 === 2) ? tallH : baseH)
    }));

    // distribute greedily to keep column heights balanced
    const cols = Array.from({length: columns}, ()=>({items: [], total:0}));
    items.forEach(item=>{
        // find index of shortest column
        let idx = 0;
        for (let j=1;j<cols.length;j++){
            if (cols[j].total < cols[idx].total) idx = j;
        }
        cols[idx].items.push(item);
        cols[idx].total += item.height + gap;
    });

    return (
        <div className="columns">
            {cols.map((col, ci)=> (
                <div className="column" key={ci}>
                    {col.items.map(it=> (
                        <div key={it.i} className={`masonry-item`} style={{height: `${it.height}px`}}>
                            <img src={it.src} className='img-responsive' alt="" onClick={()=> onClickImage(it.src, it.i)} />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}

export default Gallery;




